import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

// Configuración: Reemplaza estos valores por los tuyos
const WHATSAPP_PHONE_NUMBER = "50256858787";
const WHATSAPP_GREETING_MESSAGE = "¡Hola! Estoy interesado en las plazas vacantes o productos/servicios. Enviado desde jsbackup.com";

// Componente que representa el botón de WhatsApp
const WhatsAppButton = () => {
  if (!WHATSAPP_PHONE_NUMBER) {
    console.warn("El número de WhatsApp no está configurado. El botón no se mostrará.");
    return null;
  }

  // Codificar el mensaje para la URL
  const encodedMessage = encodeURIComponent(WHATSAPP_GREETING_MESSAGE);
  const whatsappLink = `https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      title="Chatea con nosotros en WhatsApp"
      style={{
        position: 'fixed',
        bottom: '0.5rem',
        right: '1.5rem',
        backgroundColor: '#25D366',
        color: '#fff',
        padding: '1.5rem', // Aumenta el área clicable
        borderRadius: '50%',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
        transition: 'transform 0.3s ease',
        zIndex: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none'
      }}
      onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.1)')}
      onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <FaWhatsapp size={40} />
    </a>
  );
};

export default WhatsAppButton;